import type { EmailRoutingDefinitionJson } from '@utils/emailHostRouting';

const EMPTY_DEVELOPMENT_ROUTING_JSON: EmailRoutingDefinitionJson = {
  rules: [],
};

const devRoutingContext = require.context(
  './',
  false,
  /^\.\/emailRouting\.development\.json$/
);

const devRoutingKeys = devRoutingContext.keys();

const developmentRoutingJson: EmailRoutingDefinitionJson =
  devRoutingKeys.length > 0
    ? (devRoutingContext(devRoutingKeys[0]) as EmailRoutingDefinitionJson)
    : EMPTY_DEVELOPMENT_ROUTING_JSON;

export default developmentRoutingJson;
